import { render, staticRenderFns } from "./gmvStatistics.vue?vue&type=template&id=6aa2451f&scoped=true"
import script from "./gmvStatistics.vue?vue&type=script&lang=js"
export * from "./gmvStatistics.vue?vue&type=script&lang=js"
import style0 from "./gmvStatistics.vue?vue&type=style&index=0&id=6aa2451f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa2451f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6aa2451f')) {
      api.createRecord('6aa2451f', component.options)
    } else {
      api.reload('6aa2451f', component.options)
    }
    module.hot.accept("./gmvStatistics.vue?vue&type=template&id=6aa2451f&scoped=true", function () {
      api.rerender('6aa2451f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataAdmin/gmvStatistics.vue"
export default component.exports